const COMPONENT = '#navicon';

export default function(isBackEnd) {
  if (isBackEnd)
  {
    return;
  }

  $(COMPONENT).on('click', () => {
    $('body').toggleClass('navigation-is-open');
  });
}
